
import React, { useState, useEffect } from 'react';
import { Rule } from '../types';

interface RuleModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (ruleData: Omit<Rule, 'id' | 'type'>, id?: string) => void;
    categories: string[];
    ruleToEdit?: Rule | null;
}

const RuleModal: React.FC<RuleModalProps> = ({ isOpen, onClose, onSave, categories, ruleToEdit }) => {
    const [concept, setConcept] = useState('');
    const [category, setCategory] = useState('');

    useEffect(() => {
        if (isOpen) {
            if (ruleToEdit) {
                setConcept(ruleToEdit.concept);
                setCategory(ruleToEdit.category);
            } else {
                setConcept('');
                setCategory('');
            }
        }
    }, [ruleToEdit, isOpen]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!concept.trim() || !category) {
            alert('Por favor, completa el concepto clave y selecciona una categoría.');
            return;
        }
        onSave({ concept: concept.trim(), category }, ruleToEdit?.id);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center" onClick={onClose}>
            <div className="bg-light-surface dark:bg-surface rounded-lg shadow-xl p-8 w-[95%] sm:w-full max-w-lg border border-light-border dark:border-border" onClick={e => e.stopPropagation()}>
                <h2 className="text-2xl font-bold text-light-text-primary dark:text-text-primary mb-6">
                    {ruleToEdit ? 'Editar Regla' : 'Crear Nueva Regla'}
                </h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="ruleConcept" className="block text-sm font-medium text-light-text-secondary dark:text-text-secondary mb-1">
                           Si el concepto contiene...
                        </label>
                        <input
                            type="text"
                            id="ruleConcept"
                            value={concept}
                            onChange={e => setConcept(e.target.value)}
                            required
                            className="w-full bg-light-background dark:bg-background border border-light-border dark:border-border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
                            placeholder="Ej: Amazon, Netflix, Alquiler"
                        />
                        <p className="text-xs text-light-text-secondary dark:text-text-secondary mt-1">Introduce una palabra o frase clave para identificar la transacción.</p>
                    </div>
                    <div>
                        <label htmlFor="ruleCategory" className="block text-sm font-medium text-light-text-secondary dark:text-text-secondary mb-1">
                            Asignar a la categoría...
                        </label>
                        <select
                            id="ruleCategory"
                            value={category}
                            onChange={e => setCategory(e.target.value)}
                            required
                            className="w-full bg-light-background dark:bg-background border border-light-border dark:border-border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
                        >
                            <option value="" disabled>Selecciona una categoría</option>
                            {categories.filter(c => c !== "Desconocida").sort().map(cat => (
                                <option key={cat} value={cat}>{cat}</option>
                            ))}
                        </select>
                    </div>
                    <div className="flex justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="px-4 py-2 rounded-md bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-500 text-light-text-primary dark:text-text-primary transition-colors">Cancelar</button>
                        <button type="submit" className="px-6 py-2 rounded-md bg-primary hover:bg-blue-600 text-white font-semibold transition-colors">
                            {ruleToEdit ? 'Guardar Cambios' : 'Crear Regla'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RuleModal;
